export default __webpack_public_path__ + "static/media/Asset 4.5ff1185a.png";